import type { Circuit } from '../../api/types';
import ScoreBadge from '../ScoreBadge';
import MetricList from '../MetricList';
import { Badge, cx } from '../ui';
import { EVENT_LABELS, fmtDuration } from '../../lib/format';

export default function CircuitPanel({ circuits, selected, onSelect, startTs }: { circuits: Circuit[]; selected: number | null; onSelect: (seq: number | null) => void; startTs: number }) {
  return (
    <div>
      <ul className="divide-y divide-line">
        {circuits.map(c => {
          const open = selected === c.seq;
          return (
            <li key={c.seq}>
              <button onClick={() => onSelect(open ? null : c.seq)} className={cx('w-full text-left px-4 py-2.5 flex items-center gap-3 hover:bg-line/50', open && 'bg-line/60')}>
                <div className="flex-1 min-w-0">
                  <div className="text-sm font-medium">{c.kind === 'circuit' ? `Circuit ${c.seq + 1}` : c.kind === 'departure' ? 'Departure' : c.overallScore !== null ? 'Arrival (pattern)' : 'Arrival (straight-in)'} <span className="text-dim font-normal">· {c.runway} {c.direction ?? ''}</span></div>
                  <div className="text-xs text-dim hud">{fmtDuration(c.startTs - startTs)}–{fmtDuration(c.endTs - startTs)} · {c.endEvent ? EVENT_LABELS[c.endEvent] : '—'}
                    {c.needsReview && <Badge className="ml-2 bg-amber/15 text-amber">review</Badge>}
                    {c.runwayConfidence < 0.6 && <Badge className="ml-1 bg-rose/15 text-rose">rwy {Math.round(c.runwayConfidence * 100)}%</Badge>}</div>
                </div>
                {c.overallScore !== null && <><ScoreBadge score={c.patternScore} label="pattern" size="sm" /><ScoreBadge score={c.approachScore} label="approach" size="sm" /><ScoreBadge score={c.overallScore} label="overall" size="sm" /></>}
              </button>
              {open && c.overallScore !== null && (
                <div className="px-4 pb-3 bg-ink/40">
                  {c.reviewReasons.length > 0 && <div className="text-xs text-amber py-2">{c.reviewReasons.join(' · ')}</div>}
                  {c.dtwDistance !== null && <div className="text-[11px] text-dim py-1">pattern conformance (DTW) {c.dtwDistance.toFixed(2)}</div>}
                  <div className="text-xs uppercase tracking-wide text-dim pt-2">Pattern</div><MetricList metrics={c.metrics.pattern} />
                  <div className="text-xs uppercase tracking-wide text-dim pt-3">Approach</div><MetricList metrics={c.metrics.approach} />
                </div>
              )}
            </li>
          );
        })}
      </ul>
      {!circuits.length && <div className="p-4 text-sm text-dim">No circuits detected.</div>}
    </div>
  );
}
